/* Metal Rooster theme — storefront behaviour
   Cart drawer, fly-to-cart, quick add, format filter, product page, Look inside, contact topics. */
(function () {
  'use strict';

  var theme = window.theme || {};
  var strings = theme.strings || {};
  var routes = theme.routes || {};
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- Helpers ---------- */

  function formatMoney(cents) {
    var format = (theme.moneyFormat || '${{amount}}').replace(/<[^>]*>/g, '');
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function delimit(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (number === null || isNaN(number)) return '0';
      var parts = (number / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }

    var match = format.match(placeholder);
    if (!match) return format;
    var value;
    switch (match[1]) {
      case 'amount_no_decimals':
        value = delimit(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = delimit(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = delimit(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = delimit(cents, 2, "'", '.');
        break;
      case 'amount_with_space_separator':
        value = delimit(cents, 2, ' ', ',');
        break;
      default:
        value = delimit(cents, 2);
    }
    return format.replace(placeholder, value);
  }

  function qsa(root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  function fill(template, values) {
    return String(template || '').replace(/\[(\w+)\]/g, function (all, key) {
      return values[key] !== undefined ? values[key] : all;
    });
  }

  function same(a, b) {
    return String(a).trim().toLowerCase() === String(b).trim().toLowerCase();
  }

  function motionOK() {
    return !(reduceMotion && reduceMotion.matches);
  }

  function isVisible(el) {
    if (!el || !el.getClientRects().length) return false;
    var rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
  }

  /* ---------- Quantity steppers ---------- */

  document.addEventListener('click', function (event) {
    var step = event.target.closest('[data-qty-step]');
    if (!step) return;
    var wrapper = step.closest('.qty');
    var input = wrapper && wrapper.querySelector('input');
    if (!input) return;
    var min = input.min !== '' ? parseInt(input.min, 10) : 1;
    var next = (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-qty-step'), 10);
    input.value = Math.max(min, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart page: update on quantity change ---------- */

  var cartUpdateTimer;
  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-cart-qty-input]');
    if (!input) return;
    var form = input.closest('form');
    var button = form && form.querySelector('[data-cart-update]');
    clearTimeout(cartUpdateTimer);
    cartUpdateTimer = setTimeout(function () {
      if (form.requestSubmit && button) form.requestSubmit(button);
      else if (button) button.click();
    }, 500);
  });

  /* ---------- Collection sort ---------- */

  document.addEventListener('change', function (event) {
    var form = event.target.closest('form[data-auto-submit]');
    if (form && event.target.tagName === 'SELECT') form.submit();
  });

  /* ---------- Close header disclosures on outside click / Escape ---------- */

  var disclosureSelector = '.header__menu-mobile[open], .header-search[open], .header__dropdown[open]';

  document.addEventListener('click', function (event) {
    qsa(document, disclosureSelector).forEach(function (details) {
      if (!details.contains(event.target)) details.removeAttribute('open');
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    qsa(document, disclosureSelector).forEach(function (details) {
      details.removeAttribute('open');
      var summary = details.querySelector('summary');
      if (summary && details.contains(document.activeElement)) summary.focus();
    });
  });

  /* ---------- Cart drawer ---------- */

  var lastFocus = null;

  function getDrawer() {
    return document.querySelector('[data-cart-drawer]');
  }

  function onCartPage() {
    return !!document.querySelector('[data-cart-form]');
  }

  function drawerEnabled() {
    return theme.cartType === 'drawer' && !!getDrawer() && !onCartPage();
  }

  function updateCartCount(count) {
    if (count === null || count === undefined) return;
    qsa(document, '[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', String(count) === '0');
    });
  }

  function countFromSection(html) {
    if (!html) return null;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cart-drawer]');
    return fresh ? fresh.getAttribute('data-item-count') : null;
  }

  function renderDrawer(html) {
    var drawer = getDrawer();
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cart-drawer]');
    if (!fresh) return;
    if (drawer) {
      drawer.querySelector('[data-cart-panel]').innerHTML = fresh.querySelector('[data-cart-panel]').innerHTML;
      drawer.setAttribute('data-item-count', fresh.getAttribute('data-item-count'));
    }
    return fresh.getAttribute('data-item-count');
  }

  function refreshDrawer() {
    var url = (routes.root || '/').replace(/\/?$/, '/') + '?sections=cart-drawer';
    return fetch(url)
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        updateCartCount(renderDrawer(data['cart-drawer']));
      });
  }

  function openDrawer() {
    var drawer = getDrawer();
    if (!drawer || drawer.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    hideToast(true);
    drawer.classList.add('is-open');
    drawer.removeAttribute('inert');
    document.documentElement.classList.add('drawer-open');
    var panel = drawer.querySelector('[data-cart-panel]');
    if (panel) panel.focus();
  }

  function closeDrawer() {
    var drawer = getDrawer();
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('inert', '');
    document.documentElement.classList.remove('drawer-open');
    if (lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus();
  }

  function changeLine(line, quantity) {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.classList.add('is-loading');
    fetch(routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        line: parseInt(line, 10),
        quantity: Math.max(0, parseInt(quantity, 10)),
        sections: 'cart-drawer',
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data.sections) return updateCartCount(renderDrawer(data.sections['cart-drawer']));
        return refreshDrawer();
      })
      .catch(refreshDrawer)
      .then(function () {
        drawer.classList.remove('is-loading');
        var panel = drawer.querySelector('[data-cart-panel]');
        if (panel) panel.focus();
      });
  }

  function isCartLink(link) {
    if (!link || link.tagName !== 'A' || !link.href) return false;
    if (link.hasAttribute('data-no-drawer') || link.target === '_blank') return false;
    if (link.closest('[data-cart-drawer]')) return false;
    try {
      var url = new URL(link.href, window.location.href);
      var cartPath = new URL(routes.cart || '/cart', window.location.href).pathname;
      return url.origin === window.location.origin && url.pathname.replace(/\/$/, '') === cartPath.replace(/\/$/, '') && !url.search && !url.hash;
    } catch (e) {
      return false;
    }
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var opener = event.target.closest('[data-cart-open]') || (isCartLink(event.target.closest('a')) ? event.target.closest('a') : null);
    if (opener && drawerEnabled()) {
      event.preventDefault();
      var menu = opener.closest('details[open]');
      if (menu) menu.removeAttribute('open');
      openDrawer();
      return;
    }
    if (event.target.closest('[data-cart-close]')) {
      closeDrawer();
      return;
    }
    var change = event.target.closest('[data-cart-change]');
    if (change) {
      changeLine(change.getAttribute('data-line'), change.getAttribute('data-cart-change'));
    }
  });

  document.addEventListener('keydown', function (event) {
    var drawer = getDrawer();
    if (!drawer || !drawer.classList.contains('is-open')) return;
    if (event.key === 'Escape') {
      closeDrawer();
      return;
    }
    if (event.key !== 'Tab') return;
    var focusable = qsa(drawer, 'a[href], button:not([disabled]), input, textarea, select, [tabindex]:not([tabindex="-1"])').filter(
      function (el) {
        return el.offsetParent !== null;
      }
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  /* ---------- Fly to cart ---------- */

  function cartTarget() {
    var icons = qsa(document, '[data-cart-icon]').filter(isVisible);
    if (!icons.length) return null;
    var icon = icons[0];
    return { button: icon, landing: icon.querySelector('svg') || icon };
  }

  function sourceImage(form) {
    var scope = form.closest('[data-card]');
    var img = scope && scope.querySelector('[data-card-media] img');
    if (!img) {
      var section = form.closest('[data-product-section]');
      if (section) img = section.querySelector('.gallery__item.is-active img') || section.querySelector('.gallery__item img');
    }
    return img && isVisible(img) ? img : null;
  }

  function bumpCart(target) {
    if (!target) target = cartTarget();
    if (!target) return;
    var button = target.button;
    button.classList.remove('is-bumped');
    void button.offsetWidth;
    button.classList.add('is-bumped');
    window.setTimeout(function () {
      button.classList.remove('is-bumped');
    }, 700);
  }

  function flyToCart(img, fallbackEl) {
    var target = cartTarget();
    if (!target || !motionOK() || !Element.prototype.animate) {
      return Promise.resolve(target);
    }
    var startEl = img || fallbackEl;
    if (!startEl) return Promise.resolve(target);

    var from = startEl.getBoundingClientRect();
    var to = target.landing.getBoundingClientRect();
    var vh = window.innerHeight;
    // Use the part of the source that is on screen; if most of the image is scrolled away, launch from the button.
    var visibleH = Math.max(0, Math.min(from.bottom, vh) - Math.max(from.top, 0));
    var size;
    var height;
    var cx;
    var cy;
    if (img && visibleH < from.height * 0.45 && fallbackEl) {
      var b = fallbackEl.getBoundingClientRect();
      size = 96;
      height = (size * from.height) / from.width;
      cx = b.left + b.width / 2;
      cy = b.top + b.height / 2;
    } else {
      size = Math.min(Math.max(from.width, 60), 240);
      height = img ? (size * from.height) / from.width : size;
      cx = from.left + from.width / 2;
      cy = Math.max(from.top, 0) + visibleH / 2 || from.top + from.height / 2;
    }
    var startX = cx - size / 2;
    var startY = cy - height / 2;
    var endX = to.left + to.width / 2 - size / 2;
    var endY = to.top + to.height / 2 - height / 2;
    var endScale = Math.max(to.width, 18) / size;

    var flyer = document.createElement('div');
    flyer.className = 'fly-item' + (img ? '' : ' fly-item--dot');
    flyer.style.width = size + 'px';
    flyer.style.height = height + 'px';
    flyer.style.left = '0px';
    flyer.style.top = '0px';
    if (img) {
      var clone = document.createElement('img');
      clone.src = img.currentSrc || img.src;
      clone.alt = '';
      flyer.appendChild(clone);
    }
    document.body.appendChild(flyer);

    // Arc: a quadratic curve lifted above both points.
    var ctrlX = startX + (endX - startX) * 0.35;
    var ctrlY = Math.max(Math.min(startY, endY) - Math.max(120, Math.abs(endX - startX) * 0.25), -height * 0.25);
    var frames = [];
    var steps = 24;
    for (var i = 0; i <= steps; i++) {
      var t = i / steps;
      var e = t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      var x = (1 - e) * (1 - e) * startX + 2 * (1 - e) * e * ctrlX + e * e * endX;
      var y = (1 - e) * (1 - e) * startY + 2 * (1 - e) * e * ctrlY + e * e * endY;
      var s = 1 + (endScale - 1) * Math.pow(e, 0.85);
      var r = Math.sin(e * Math.PI) * -10;
      frames.push({
        transform: 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px) scale(' + s.toFixed(3) + ') rotate(' + r.toFixed(1) + 'deg)',
        opacity: t > 0.88 ? 1 - (t - 0.88) * 5 : 1,
        offset: t
      });
    }

    return new Promise(function (resolve) {
      var animation = flyer.animate(frames, { duration: 820, easing: 'linear', fill: 'forwards' });
      var done = function () {
        flyer.remove();
        resolve(target);
      };
      animation.onfinish = done;
      animation.oncancel = done;
    });
  }

  /* ---------- Added-to-cart toast ---------- */

  var toastEl = null;
  var toastTimer = null;

  function hideToast(immediate) {
    if (!toastEl) return;
    clearTimeout(toastTimer);
    toastEl.classList.remove('is-visible');
    if (immediate) toastEl.hidden = true;
    else
      window.setTimeout(function () {
        if (toastEl && !toastEl.classList.contains('is-visible')) toastEl.hidden = true;
      }, 300);
  }

  function scheduleToastHide() {
    clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () {
      if (toastEl && (toastEl.matches(':hover') || toastEl.contains(document.activeElement))) return scheduleToastHide();
      hideToast();
    }, 4500);
  }

  function showToast(item) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'cart-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      toastEl.hidden = true;
      document.body.appendChild(toastEl);
      toastEl.addEventListener('click', function (event) {
        if (event.target.closest('[data-toast-close]')) hideToast();
      });
    }
    toastEl.innerHTML = '';

    if (item && item.image) {
      var thumb = document.createElement('img');
      thumb.className = 'cart-toast__img';
      thumb.alt = '';
      thumb.src = item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=120';
      toastEl.appendChild(thumb);
    }

    var copy = document.createElement('div');
    copy.className = 'cart-toast__copy';
    var title = document.createElement('strong');
    title.textContent = strings.added || 'Added to cart';
    copy.appendChild(title);
    if (item && item.product_title) {
      var name = document.createElement('span');
      name.textContent = item.product_title + (item.variant_title ? ' · ' + item.variant_title : '');
      copy.appendChild(name);
    }
    toastEl.appendChild(copy);

    var view;
    if (drawerEnabled()) {
      view = document.createElement('button');
      view.type = 'button';
      view.setAttribute('data-cart-open', '');
    } else {
      view = document.createElement('a');
      view.href = routes.cart || '/cart';
    }
    view.className = 'btn btn--primary cart-toast__btn';
    view.textContent = strings.viewCart || 'View cart';
    toastEl.appendChild(view);

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'cart-toast__close';
    close.setAttribute('data-toast-close', '');
    close.setAttribute('aria-label', strings.close || 'Close');
    close.innerHTML = '<svg aria-hidden="true" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg>';
    toastEl.appendChild(close);

    toastEl.hidden = false;
    void toastEl.offsetWidth;
    toastEl.classList.add('is-visible');
    scheduleToastHide();
  }

  /* ---------- Add to cart (AJAX) ---------- */

  function busy(scope, on, states) {
    var controls = qsa(scope, '[data-add-button], [data-card-add-option]');
    if (on) {
      return controls.map(function (b) {
        var was = b.disabled;
        b.disabled = true;
        b.setAttribute('aria-busy', 'true');
        return was;
      });
    }
    controls.forEach(function (b, i) {
      b.disabled = states && states[i] !== undefined ? states[i] : false;
      b.removeAttribute('aria-busy');
    });
  }

  function flashAdded(scope) {
    qsa(scope, '[data-add-button]').forEach(function (button) {
      if (!button.offsetParent) return;
      button.classList.add('is-added');
      window.setTimeout(function () {
        button.classList.remove('is-added');
      }, 1600);
    });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-product-form]');
    if (!form || onCartPage() || !window.fetch) return;
    event.preventDefault();

    var scope = form.closest('[data-card]') || form.closest('[data-product-section]') || form;
    var errorEl = form.querySelector('[data-form-error]');
    var states = busy(scope, true);
    var trigger = event.submitter || form.querySelector('[type="submit"]');
    var img = sourceImage(form);

    var body = new FormData(form);
    body.append('sections', 'cart-drawer');
    body.append('sections_url', window.location.pathname);

    fetch(routes.cartAdd + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok || result.data.status) {
          if (errorEl) {
            errorEl.textContent = result.data.description || result.data.message || strings.cartError;
            errorEl.hidden = false;
          }
          return;
        }
        if (errorEl) errorEl.hidden = true;

        var item = result.data.items ? result.data.items[0] : result.data;
        var drawerHtml = result.data.sections && result.data.sections['cart-drawer'];
        var count = drawerHtml ? renderDrawer(drawerHtml) || countFromSection(drawerHtml) : null;
        var after = theme.afterAdd || 'fly';
        flashAdded(scope);

        document.dispatchEvent(new CustomEvent('cart:added', { detail: { item: item } }));

        var flight = after === 'open' ? Promise.resolve(null) : flyToCart(img, trigger);
        return flight.then(function (target) {
          if (count !== null) updateCartCount(count);
          else refreshDrawer().catch(function () {});
          bumpCart(target);
          if ((after === 'open' || after === 'fly_open') && drawerEnabled()) openDrawer();
          else showToast(item);
        });
      })
      .catch(function () {
        if (errorEl) {
          errorEl.textContent = strings.cartError;
          errorEl.hidden = false;
        }
      })
      .then(function () {
        busy(scope, false, states);
        refreshCardControls(scope);
      });
  });

  /* ---------- Cards: swatches, size quick add, format filter ---------- */

  function cardData(card) {
    if (card._data !== undefined) return card._data;
    var el = card.querySelector('[data-card-json]');
    try {
      card._data = el ? JSON.parse(el.textContent) : null;
    } catch (e) {
      card._data = null;
    }
    if (card._data) {
      var idInput = card.querySelector('[data-variant-id]');
      var current = idInput &&
        card._data.variants.filter(function (v) {
          return String(v.id) === idInput.value;
        })[0];
      card._selected = (current || card._data.variants[0]).options.slice();
    }
    return card._data;
  }

  function matchVariant(data, selected) {
    var exact = data.variants.filter(function (v) {
      return v.options.every(function (value, i) {
        return selected[i] === undefined || selected[i] === null || same(value, selected[i]);
      });
    });
    return (
      exact.filter(function (v) {
        return v.available;
      })[0] ||
      exact[0] ||
      null
    );
  }

  function refreshCardControls(card) {
    if (!card || !card.matches || !card.matches('[data-card]')) return;
    var data = cardData(card);
    if (!data) return;
    qsa(card, '[data-card-add-option]').forEach(function (chip) {
      var index = parseInt(chip.getAttribute('data-card-add-option'), 10);
      var trial = card._selected.slice();
      trial[index] = chip.getAttribute('data-value');
      var variant = data.variants.filter(function (v) {
        return v.options.every(function (value, i) {
          return same(value, trial[i]);
        });
      })[0];
      chip.disabled = !(variant && variant.available);
    });
  }

  function selectCardOption(card, index, value) {
    var data = cardData(card);
    if (!data) return null;
    card._selected[index] = value;
    var variant = matchVariant(data, card._selected);
    if (!variant) return null;

    qsa(card, '[data-card-option="' + index + '"]').forEach(function (swatch) {
      swatch.setAttribute('aria-pressed', same(swatch.getAttribute('data-value'), value) ? 'true' : 'false');
    });
    var label = card.querySelector('[data-card-option-label="' + index + '"]');
    if (label) label.textContent = value;

    var idInput = card.querySelector('[data-variant-id]');
    if (idInput) idInput.value = variant.id;

    var img = card.querySelector('[data-card-media] img');
    if (variant.image && img) {
      img.removeAttribute('srcset');
      img.src = variant.image;
    }
    refreshCardControls(card);
    return variant;
  }

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('[data-card-option]');
    if (swatch) {
      var card = swatch.closest('[data-card]');
      selectCardOption(card, parseInt(swatch.getAttribute('data-card-option'), 10), swatch.getAttribute('data-value'));
      return;
    }

    var chip = event.target.closest('[data-card-add-option]');
    if (chip && !chip.disabled) {
      var chipCard = chip.closest('[data-card]');
      var variant = selectCardOption(chipCard, parseInt(chip.getAttribute('data-card-add-option'), 10), chip.getAttribute('data-value'));
      var form = chip.closest('form');
      if (variant && variant.available && form) {
        chip.classList.add('is-picked');
        window.setTimeout(function () {
          chip.classList.remove('is-picked');
        }, 900);
        if (form.requestSubmit) form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    }
  });

  function applyFormatFilter(section, value) {
    var shown = 0;
    qsa(section, '[data-card]').forEach(function (card) {
      var quick = card.querySelector('[data-card-quick]');
      var link = card.querySelector('[data-card-link]');
      var index = parseInt(card.getAttribute('data-format-index'), 10);
      qsa(card, '[data-format]').forEach(function (row) {
        row.classList.toggle('is-selected', !!value && same(row.getAttribute('data-format'), value));
      });
      card.classList.remove('is-dimmed');
      if (!quick) return;

      var data = cardData(card);
      var variant = null;
      if (value && data && !isNaN(index)) {
        var selected = [];
        selected[index] = value;
        variant = matchVariant(data, selected);
      }

      if (variant && variant.available) {
        card._selected = variant.options.slice();
        card.querySelector('[data-variant-id]').value = variant.id;
        quick.querySelector('[data-add-label]').textContent = fill(strings.quickAdd || 'Add [format] · [price]', {
          format: value,
          price: formatMoney(variant.price)
        });
        quick.hidden = false;
        if (link) link.hidden = true;
        shown++;
      } else {
        quick.hidden = true;
        if (link) link.hidden = false;
        if (value) card.classList.add('is-dimmed');
      }
    });
    var status = section.querySelector('[data-filter-status]');
    if (status) status.textContent = value ? fill(strings.filterStatus || '[value]: [count]', { value: value, count: shown }) : '';
  }

  document.addEventListener('click', function (event) {
    var chip = event.target.closest('[data-format-filter] [data-value]');
    if (!chip) return;
    var group = chip.closest('[data-format-filter]');
    qsa(group, '[data-value]').forEach(function (b) {
      b.setAttribute('aria-pressed', b === chip ? 'true' : 'false');
    });
    applyFormatFilter(chip.closest('[data-collection]') || document, chip.getAttribute('data-value'));
  });

  /* ---------- Product: gallery, format picker, sticky bar ---------- */

  function showMedia(section, mediaId) {
    var target = section.querySelector('.gallery__item[data-media-id="' + mediaId + '"]');
    if (!target) return;
    qsa(section, '.gallery__item').forEach(function (item) {
      item.classList.toggle('is-active', item === target);
    });
    qsa(section, '[data-thumb]').forEach(function (thumb) {
      thumb.setAttribute('aria-current', thumb.getAttribute('data-thumb') === String(mediaId) ? 'true' : 'false');
    });
  }

  function initProduct(section) {
    if (section.hasAttribute('data-ready')) return;
    section.setAttribute('data-ready', '');

    var jsonEl = section.querySelector('[data-product-json]');
    var product = null;
    try {
      product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    } catch (e) {
      product = null;
    }

    var variantMetaEl = section.querySelector('[data-variant-meta-json]');
    var variantMeta = {};
    try {
      variantMeta = variantMetaEl ? JSON.parse(variantMetaEl.textContent) : {};
    } catch (e) {
      variantMeta = {};
    }
    var variantTab = section.querySelector('[data-li-variant-tab]');
    var variantTabTemplate = variantTab ? variantTab.getAttribute('data-tab-template') || '' : '';

    function updateVariantTab(variant) {
      if (!variantTab) return;
      var meta = variantMeta[variant.id] || {};
      var text = variantTabTemplate;
      if (meta.pages) text = text.split('[PAGES]').join(meta.pages);
      if (meta.isbn) text = text.split('[ISBN]').join(meta.isbn);
      variantTab.innerHTML = text;
    }

    section.addEventListener('click', function (event) {
      var thumb = event.target.closest('[data-thumb]');
      if (thumb) showMedia(section, thumb.getAttribute('data-thumb'));
    });

    var picker = section.querySelector('[data-variant-picker]');
    var form = section.querySelector('form[data-product-form]');
    var idInput = form && form.querySelector('[data-variant-id]');

    function selectedOptions() {
      return qsa(picker, 'fieldset').map(function (fieldset) {
        var checked = fieldset.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(options) {
      if (!product) return null;
      return (
        product.variants.find(function (variant) {
          return variant.options.every(function (value, index) {
            return value === options[index];
          });
        }) || null
      );
    }

    function setButtons(label, disabled) {
      qsa(section, '[data-add-button]').forEach(function (button) {
        button.disabled = disabled;
        var labelEl = button.querySelector('[data-add-label]');
        if (labelEl) labelEl.textContent = label;
      });
    }

    function update() {
      var options = selectedOptions();
      qsa(picker, 'fieldset').forEach(function (fieldset, index) {
        var selected = fieldset.querySelector('[data-selected-value]');
        if (selected) selected.textContent = options[index] || '';
      });

      var variant = findVariant(options);
      if (!variant) {
        setButtons(strings.unavailable, true);
        return;
      }

      if (idInput) {
        idInput.value = variant.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      updateVariantTab(variant);

      var price = section.querySelector('[data-price]');
      if (price) {
        price.innerHTML = '';
        var current = document.createElement('span');
        current.textContent = formatMoney(variant.price);
        price.appendChild(current);
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          var compare = document.createElement('s');
          compare.textContent = formatMoney(variant.compare_at_price);
          price.appendChild(compare);
        }
      }

      qsa(section, '[data-add-price], [data-sticky-price]').forEach(function (el) {
        el.textContent = formatMoney(variant.price);
      });
      var stickyVariant = section.querySelector('[data-sticky-variant]');
      if (stickyVariant) stickyVariant.textContent = variant.title;

      setButtons(variant.available ? strings.addToCart : strings.soldOut, !variant.available);

      var digital = variant.requires_shipping === false;
      qsa(section, '[data-delivery="digital"]').forEach(function (el) {
        el.hidden = !digital;
      });
      qsa(section, '[data-delivery="physical"]').forEach(function (el) {
        el.hidden = digital;
      });
      var qty = section.querySelector('[data-qty]');
      if (qty) {
        qty.hidden = digital;
        var qtyInput = qty.querySelector('input');
        if (digital && qtyInput) qtyInput.value = 1;
      }

      if (variant.featured_media) showMedia(section, variant.featured_media.id);

      var errorEl = section.querySelector('[data-form-error]');
      if (errorEl) errorEl.hidden = true;

      if (window.history && window.history.replaceState && section.getAttribute('data-product-url')) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    if (picker && product) picker.addEventListener('change', update);

    var sticky = section.querySelector('[data-sticky-buy]');
    var mainButton = form && form.querySelector('[data-add-button]');
    if (sticky && mainButton) {
      var stickyButton = sticky.querySelector('button');
      var ticking = false;
      var syncSticky = function () {
        ticking = false;
        var show = mainButton.getBoundingClientRect().bottom < 0;
        if (sticky.classList.contains('is-visible') === show) return;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (stickyButton) stickyButton.tabIndex = show ? 0 : -1;
      };
      window.addEventListener(
        'scroll',
        function () {
          if (!ticking) {
            ticking = true;
            window.requestAnimationFrame(syncSticky);
          }
        },
        { passive: true }
      );
      syncSticky();
    }

    initLookInside(section, picker, form);
  }

  /* ---------- Look inside (sample pages) ---------- */

  function initLookInside(section, picker, form) {
    var dialog = section.querySelector('[data-look-inside]');
    if (!dialog || typeof dialog.showModal !== 'function') {
      qsa(section, '[data-li-open]').forEach(function (b) {
        b.hidden = true;
      });
      return;
    }

    var pages = qsa(dialog, '[data-li-page]');
    var book = dialog.querySelector('[data-li-book]');
    var counter = dialog.querySelector('[data-li-counter]');
    var thumbs = dialog.querySelector('[data-li-thumbs]');
    var prev = dialog.querySelector('[data-li-prev]');
    var next = dialog.querySelector('[data-li-next]');
    var wide = window.matchMedia('(min-width: 750px)');
    var hasCover = pages[0] && pages[0].getAttribute('data-kind') === 'cover';
    var spreads = [];
    var current = 0;

    function pageName(i) {
      var kind = pages[i].getAttribute('data-kind');
      if (kind === 'cover') return dialog.getAttribute('data-label-cover') || 'Cover';
      if (kind === 'end') return dialog.getAttribute('data-label-end') || 'End';
      return String(hasCover ? i : i + 1);
    }

    function spreadLabel(spread) {
      if (spread.length === 1) return pageName(spread[0]);
      var a = pageName(spread[0]);
      var b = pageName(spread[1]);
      return /^\d+$/.test(a) && /^\d+$/.test(b) ? a + '–' + b : a + ' · ' + b;
    }

    function thumbSrc(page) {
      var img = page.querySelector('img');
      if (!img) return null;
      var src = img.getAttribute('src') || '';
      return /width=\d+/.test(src) ? src.replace(/width=\d+/, 'width=120') : src;
    }

    function build() {
      spreads = [];
      var i = 0;
      if (wide.matches) {
        if (hasCover) {
          spreads.push([0]);
          i = 1;
        }
        for (; i < pages.length; i += 2) spreads.push(pages[i + 1] ? [i, i + 1] : [i]);
      } else {
        pages.forEach(function (p, index) {
          spreads.push([index]);
        });
      }

      thumbs.innerHTML = '';
      spreads.forEach(function (spread, index) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'li-thumb';
        button.setAttribute('aria-label', fill(dialog.getAttribute('data-label-goto') || 'Go to [label]', { label: spreadLabel(spread) }));
        var minis = document.createElement('span');
        minis.className = 'li-thumb__pages';
        spread.forEach(function (p) {
          var mini = document.createElement('span');
          mini.className = 'li-thumb__page' + (pages[p].getAttribute('data-kind') === 'end' ? ' li-thumb__page--end' : '');
          var src = thumbSrc(pages[p]);
          if (src) {
            var im = document.createElement('img');
            im.src = src;
            im.alt = '';
            im.loading = 'lazy';
            mini.appendChild(im);
          }
          minis.appendChild(mini);
        });
        var label = document.createElement('span');
        label.textContent = spreadLabel(spread);
        button.appendChild(minis);
        button.appendChild(label);
        button.addEventListener('click', function () {
          go(index);
        });
        thumbs.appendChild(button);
      });
    }

    function go(index) {
      current = Math.max(0, Math.min(index, spreads.length - 1));
      var spread = spreads[current];
      pages.forEach(function (page, i) {
        var pos = spread.indexOf(i);
        page.hidden = pos === -1;
        page.classList.toggle('is-left', spread.length === 2 && pos === 0);
        page.classList.toggle('is-right', spread.length === 2 && pos === 1);
      });
      book.classList.toggle('is-spread', spread.length === 2);
      prev.disabled = current === 0;
      next.disabled = current === spreads.length - 1;
      qsa(thumbs, '.li-thumb').forEach(function (t, i) {
        t.setAttribute('aria-current', i === current ? 'true' : 'false');
        if (i === current && t.scrollIntoView && dialog.open) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });
      var range = spreadLabel(spread);
      var numbered = pages.filter(function (p) {
        return !p.getAttribute('data-kind');
      }).length;
      var template = spread.length === 2 ? dialog.getAttribute('data-label-counter') : dialog.getAttribute('data-label-counter-one');
      counter.textContent = /^\d/.test(range) ? fill(template || '[range] / [total]', { range: range, total: numbered }) : range;
    }

    function open() {
      build();
      go(0);
      dialog.showModal();
      document.documentElement.classList.add('dialog-open');
      requestAnimationFrame(function () {
        dialog.classList.add('is-open');
      });
    }

    function close() {
      if (dialog.open) dialog.close();
    }

    dialog.addEventListener('close', function () {
      dialog.classList.remove('is-open');
      document.documentElement.classList.remove('dialog-open');
    });

    wide.addEventListener &&
      wide.addEventListener('change', function () {
        if (!dialog.open) return;
        var page = spreads[current] ? spreads[current][0] : 0;
        build();
        var target = 0;
        spreads.forEach(function (s, i) {
          if (s.indexOf(page) > -1) target = i;
        });
        go(target);
      });

    section.addEventListener('click', function (event) {
      if (event.target.closest('[data-li-open]')) {
        event.preventDefault();
        open();
      }
    });

    prev.addEventListener('click', function () {
      go(current - 1);
    });
    next.addEventListener('click', function () {
      go(current + 1);
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) return close();
      if (event.target.closest('[data-li-close]')) return close();

      var pick = event.target.closest('[data-li-pick]');
      var buy = event.target.closest('[data-li-buy]');
      if (!pick && !buy) return;
      close();
      if (pick && picker) {
        var value = pick.getAttribute('data-li-pick');
        var radio = qsa(picker, 'input[type="radio"]').filter(function (r) {
          return r.value === value;
        })[0];
        if (radio && !radio.checked) radio.click();
      }
      var focusTarget = (form && form.querySelector('[data-add-button]')) || picker;
      var scrollTarget = picker || form;
      if (scrollTarget) scrollTarget.scrollIntoView({ behavior: motionOK() ? 'smooth' : 'auto', block: 'center' });
      if (focusTarget)
        window.setTimeout(function () {
          focusTarget.focus({ preventScroll: true });
        }, motionOK() ? 350 : 0);
    });

    dialog.addEventListener('keydown', function (event) {
      if (event.target.closest('input, textarea, select')) return;
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        go(current + 1);
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        go(current - 1);
      }
    });

    var stage = dialog.querySelector('[data-li-stage]');
    var startX = null;
    var startY = null;
    stage.addEventListener(
      'pointerdown',
      function (event) {
        startX = event.clientX;
        startY = event.clientY;
      },
      { passive: true }
    );
    stage.addEventListener('pointercancel', function () {
      startX = null;
    });
    stage.addEventListener(
      'pointerup',
      function (event) {
        if (startX === null) return;
        var dx = event.clientX - startX;
        var dy = event.clientY - startY;
        startX = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(current + (dx < 0 ? 1 : -1));
      },
      { passive: true }
    );
  }

  /* ---------- Contact form topics ---------- */

  function initContact(root) {
    qsa(root, '[data-contact-form]').forEach(function (wrapper) {
      if (wrapper.hasAttribute('data-ready')) return;
      wrapper.setAttribute('data-ready', '');
      var message = wrapper.querySelector('[data-message]');
      var orderField = wrapper.querySelector('[data-order-field]');
      var sync = function () {
        var checked = wrapper.querySelector('input[name="contact[Topic]"]:checked');
        if (!checked) {
          if (orderField) orderField.hidden = false;
          return;
        }
        if (message && checked.getAttribute('data-hint')) message.placeholder = checked.getAttribute('data-hint');
        if (orderField) {
          var show = checked.hasAttribute('data-order-topic');
          orderField.hidden = !show;
          var input = orderField.querySelector('input');
          if (input) input.disabled = !show;
        }
      };
      wrapper.addEventListener('change', function (event) {
        if (event.target.name === 'contact[Topic]') sync();
      });
      sync();
    });
  }

  /* ---------- Product recommendations ---------- */

  function initRecommendations(root) {
    qsa(root, '[data-recommendations]').forEach(function (el) {
      if (el.hasAttribute('data-loaded') || !el.getAttribute('data-url')) return;
      el.setAttribute('data-loaded', '');
      fetch(el.getAttribute('data-url'))
        .then(function (response) {
          return response.text();
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var fresh = doc.querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim()) {
            el.innerHTML = fresh.innerHTML;
            qsa(el, '[data-card]').forEach(refreshCardControls);
          }
        })
        .catch(function () {});
    });
  }

  /* ---------- Init + theme editor ---------- */

  function init(root) {
    qsa(root, '[data-product-section]').forEach(initProduct);
    qsa(root, '[data-standalone-look-inside]').forEach(function (el) {
      initLookInside(el, null, null);
    });
    qsa(root, '[data-card]').forEach(refreshCardControls);
    initContact(root);
    initRecommendations(root);
    var drawer = getDrawer();
    if (drawer && !drawer.classList.contains('is-open')) drawer.setAttribute('inert', '');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:select', function (event) {
    if (event.target.querySelector('[data-cart-drawer]')) openDrawer();
  });

  document.addEventListener('shopify:section:deselect', function (event) {
    if (event.target.querySelector('[data-cart-drawer]')) closeDrawer();
  });

  window.MetalRooster = {
    openCart: openDrawer,
    closeCart: closeDrawer,
    refreshCart: refreshDrawer,
    flyToCart: flyToCart
  };
})();
